import { resolveImage, toYouTubeEmbed } from "@/lib/api";

export function VideoPlayer({ url, title = "Video", className = "" }) {
  if (!url) return null;
  const yt = toYouTubeEmbed(url);
  if (yt) {
    return (
      <div className={`aspect-video w-full overflow-hidden rounded-3xl bg-black shadow-2xl shadow-orange-100 ${className}`} data-testid="article-video-youtube">
        <iframe src={yt} title={title} className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  return (
    <video
      src={resolveImage(url)}
      controls
      preload="metadata"
      playsInline
      className={`max-h-[80vh] w-full rounded-3xl bg-black shadow-2xl shadow-orange-100 ${className}`}
      data-testid="article-video-player"
    >
      Your browser does not support video playback.
    </video>
  );
}
